import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-8 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = { class: "space-y-6 ml-4" }
const _hoisted_3 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "py-3 pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_5 = { class: "space-y-6 ml-4 overflow-y-auto" }
const _hoisted_6 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_7 = { class: "pr-6" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Print = _resolveComponent("Print")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumb),
    _createVNode(_component_DetailLayout, {
      scrollSidebar: "",
      customClass: "px-0",
      onBack: _ctx.goBack,
      title: _ctx.title,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.getDetail
    }, {
      data: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Title, {
            label: _ctx.$t('Detail Pengiriman')
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              class: "w-6/12",
              label: _ctx.$t('Nama Partner'),
              value: _ctx.detailData.consolidatorName
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-6/12",
              label: _ctx.$t('Tipe User'),
              value: "Consolidator"
            }, null, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              class: "w-6/12",
              label: _ctx.$t('Kota Asal'),
              value: _ctx.detailData.originConsolidator
            }, null, 8, ["label", "value"])
          ])
        ]),
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Title, {
            label: _ctx.$t('Detail STT')
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('Total STT'),
              class: "w-6/12",
              value: _ctx.detailData.totalStt
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('Total Koli'),
              class: "w-6/12",
              value: _ctx.detailData.totalPiece
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('Total Berat Kotor'),
              value: `${Math.ceil(_ctx.detailData.totalGrossWeight)} Kg`,
              class: "w-6/12"
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('Total Berat Dimensi'),
              value: `${Math.ceil(_ctx.detailData.totalVolumeWeight)} Kg`,
              class: "w-6/12"
            }, null, 8, ["label", "value"])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_TableV2, {
              data: _ctx.detailData.stt,
              columns: _ctx.columns,
              borderTop: false,
              hidePagination: true,
              isRightFreeze: true,
              isPinnedScrollBottom: false,
              totalColumnFreeze: 0
            }, null, 8, ["data", "columns"])
          ])
        ])
      ]),
      "sub-data": _withCtx(() => [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('Tanggal Dibuat'),
          value: _ctx.convertCreatedAt,
          caption: _ctx.detailData.createdName
        }, null, 8, ["label", "value", "caption"]),
        _hoisted_8,
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('sti.printSti')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpButton, {
              onClick: _ctx.printSummary,
              class: "mt-3 w-48",
              flat: "",
              dense: "",
              iconLeft: "print-summary",
              title: _ctx.$t('sti.printSummary')
            }, null, 8, ["onClick", "title"]),
            _createVNode(_component_LpButton, {
              onClick: _ctx.printManifest,
              class: "w-48",
              flat: "",
              iconLeft: "printer",
              dense: "",
              title: _ctx.$t('sti.printPdf')
            }, null, 8, ["onClick", "title"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]),
    _createVNode(_component_Print, { ref: "print" }, null, 512)
  ]))
}